export enum MaritalStatusEnum {
    Married = "Married",
    Unmarried = "Unmarried",
    Separated = "Separated"
}